import React from "react";
import { servicesBg_Image } from "../constants/imageConstants";
import {Link} from 'react-router-dom'


function Services() {

  return (
    <section id="services">
      <div>
        <div className="relative">
          <div  className="flex justify-center items-center flex-col py-14 gap-10">
            <h1 className="uppercase text-sm tracking-[4px] text-center">Explore our services</h1>
            <h1 className="text-5xl font-semibold text-center">We do it best.</h1>
            <h1 className="text-5xl font-semibold text-center">Let us see what we can do together</h1>
            <Link to="services_page" className="rounded-full bg-main text-white py-2 px-14 flex justify-center items-center">View all services</Link>
          </div>
        </div>
      </div>
    </section>

  );
}

export default Services;
